import React, { FC } from "react";

import { useFieldArray, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { AddressFormat, RefValue } from "@/components/molecules";
import GrayCard, { GrayCardProps } from "@/components/molecules/Cards/GrayCard/GrayCard";

import { CompanyFormType } from "../../../../formType";
import { StyledCardItem, StyledCardList } from "../styled";

const AddressCard: FC<GrayCardProps> = ({ onEdit }) => {
    const { t } = useTranslation();
    const { control } = useFormContext<CompanyFormType>();

    const { fields: addresses } = useFieldArray({
        control,
        name: "addresses",
    });

    return (
        <GrayCard title={t("Common.Address")} onEdit={onEdit}>
            <StyledCardList>
                {addresses.map((address) => (
                    <StyledCardItem $size={3} key={JSON.stringify(address)}>
                        <span>
                            <RefValue table="addressType" value={address.type.id} />
                        </span>
                        <span>
                            <AddressFormat address={address}></AddressFormat>
                        </span>
                    </StyledCardItem>
                ))}
            </StyledCardList>
        </GrayCard>
    );
};

export default AddressCard;
